import React, { Fragment, useState, useEffect } from "react";

const TeSelect = ({
    required = false,
    dataArray = [],
    selectLabel,
    label = "label",
    optionsValue = "value",
    className,
    register,
    name,
    errors = {},
    actions = [],
    onChange,
    undefinedValue = false,
    modifieValue = false,
    disabled,
}) => {
    const labelText = required ? (
        <Fragment>
            {selectLabel}
            <span className={"text-danger"}>*</span>
        </Fragment>
    ) : (
        selectLabel
    );
    return (
        <div className={`te-select ${className}`}>
            {selectLabel && labelText}
            <div className={"te-select-wrapper"}>
                <select
                    name={name}
                    ref={register}
                    onChange={e => onChange && onChange(e.target.value)}
                    className="form-control"
                    disabled={disabled}
                >
                    {undefinedValue && (
                        <option key={0} value={""}>
                            Select
                        </option>
                    )}

                    {dataArray && dataArray.length ? (
                        dataArray.map((data, index) => {
                            return (
                                <option
                                    value={
                                        modifieValue
                                            ? modifieValue(data)
                                            : data[optionsValue]
                                    }
                                    key={index + 1}
                                    selected={!undefinedValue && index === 0}
                                >
                                    {data[label]}
                                </option>
                            );
                        })
                    ) : (
                        <option value="select">Select</option>
                    )}
                </select>
                {actions && actions.length > 0 && (
                    <div className={"te-select-action"}>
                        {actions.map((item, index) => (
                            <span key={`panel-action${index}`}>{item}</span>
                        ))}
                    </div>
                )}
            </div>
            {errors.hasOwnProperty(name) && (
                <small className="error-text">
                    {errors[name].message
                        ? errors[name].message
                        : "This field is required"}
                </small>
            )}
        </div>
    );
};

export default TeSelect;
